import { SectionHeader } from "@/components/common/section-components/SectionHeader";
import { RequestSectionHeaderTitle } from "@/components/common/section-components/requests/RequestSectionHeaderTitle";
import { RequestMovementNumber } from "@/components/common/section-components/requests/RequestMovementNumber";
import { TransferRequestDetailLegend } from "@/components/common/section-components/requests/transfer/TransferRequestDetailLegend";
import { TransferRequestMessageList } from "@/components/common/section-components/requests/transfer/TransferRequestMessageList";
import { TransferRequestAmountAndActions } from "@/components/common/section-components/requests/transfer/TransferRequestAmountAndActions";
import { ECheqRequestMainDataCard } from "@/components/common/section-components/card/ECheqRequestMainDataCard";
import { AppRoutes } from "@/constants/routes";
import { AppColors } from "@/styles/colors";
import { Flex } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useRoles } from "@/hooks/useRoles";
import { ECheqRequestDetail } from "../schema/echeq-requests.schema";
import { fetchECheqRequestDetailHandler } from "../schema/handler-functions";

export const ECheqRequestDetailPage = () => {
  const [isActive, setIsActive] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [request, setRequest] = useState<ECheqRequestDetail | null>(null);

  const { id } = useParams();
  const navigate = useNavigate();
  const { fetchPermissions } = useRoles();

  useEffect(() => {
    setIsActive(true);
  }, []);

  useEffect(() => {
    if (isActive && id) {
      fetchECheqRequestDetailHandler({
        id,
        setLoadingRequest,
        setRequest,
        navigate,
        fetchPermissions,
      });
    }
  }, [isActive, id]);

  const handleBack = () => {
    navigate(AppRoutes.ECHEQ_REQUESTS);
  };

  return (
    <Flex flexDir="column" paddingTop="20px" gap="12px">
      <SectionHeader
        title={<RequestSectionHeaderTitle request={request} type="E-Cheq" />}
        onBack={handleBack}
        backButton
        loading={loadingRequest}
      />

      <RequestMovementNumber request={request} />
      {!loadingRequest && (
        <>
          <TransferRequestAmountAndActions request={request} />

          <ECheqRequestMainDataCard request={request} />

          <Flex
            flexDir="column"
            padding="12px"
            height="100%"
            border={`1px solid ${AppColors.WHITE_BORDER_1}`}
            borderRadius="12px"
            gap="25px"
          >
            <TransferRequestDetailLegend />

            <TransferRequestMessageList request={request} />
          </Flex>
        </>
      )}
    </Flex>
  );
};
